import { gql } from "@apollo/client";

const REMOVE_TOURNAMENT = gql`
  mutation softDeleteTournament($id: Float!, $password: String!) {
    softDeleteTournament(id: $id, password: $password) {
      id
      title
    }
  }
`;

export default REMOVE_TOURNAMENT;
